import { addZipCodeMask } from '@repo/ui';
import { CityData } from 'domain/value-objects';
import { CountryData } from 'domain/value-objects/country-data';

interface ReadableAddressProps {
  isRemote: boolean;
  country?: CountryData;
  nonBrazilianState?: string;
  nonBrazilianCity?: string;
  street?: string;
  addressNumber?: string;
  addressComplement?: string;
  district?: string;
  city?: CityData;
  zipCode?: string;
}

export const ReadableAddress = ({
  isRemote,
  country,
  nonBrazilianState,
  nonBrazilianCity,
  street,
  addressNumber,
  addressComplement,
  district,
  city,
  zipCode,
}: ReadableAddressProps) => {
  const isBrazil = !country || country?.id === 'BR';
  return (
    <div>
      {isRemote && (
        <span>
          Remoto
          {(street ||
            district ||
            city ||
            zipCode ||
            (country && !isBrazil) ||
            nonBrazilianState ||
            nonBrazilianCity) &&
            ' - '}
        </span>
      )}

      {isBrazil ? (
        <>
          {street && <span>{street}</span>}
          {addressNumber && <span>, {addressNumber}</span>}
          {addressComplement && <span>, {addressComplement}</span>}
          {district && <span>, {district}</span>}
          {city && <span>, {city?.name}</span>}
          {city?.federalUnit && <span> - {city?.federalUnit}</span>}
          {zipCode && <span>, {addZipCodeMask(zipCode)}</span>}
        </>
      ) : (
        <>
          {street && <span>{street}</span>}
          {addressNumber && <span>, {addressNumber}</span>}
          {addressComplement && <span>, {addressComplement}</span>}
          {district && <span>, {district}</span>}
          {nonBrazilianCity && <span>, {nonBrazilianCity}</span>}
          {nonBrazilianState && <span> - {nonBrazilianState}</span>}
          {country && <span>, {country?.name}</span>}
          {zipCode && <span> {zipCode}</span>}
        </>
      )}
    </div>
  );
};
